export const displayCars = (carData, getCheckedCars) => {
  const getCheckedCarsNumber = getCheckedCars.filter((item) => {
    if (item.isChecked === true) {
      return item;
    } else {
      return;
    }
  });

  let carInfoData =
    carData && carData.length !== 0
      ? carData.filter(function (o1) {
          return getCheckedCarsNumber.some(function (o2) {
            return o1?.Car?.CarType === o2?.carType;
          });
        })
      : [];
  return carInfoData;
};